import { GridAction } from '@eforall/dashboard';
import { VolunteerSignupSpecialistTopic } from '@interfaces';

export function getActions() {
	const actions: GridAction<VolunteerSignupSpecialistTopic>[] = [];
	return actions;
}